<template>
    <div class="choose-box" v-if="products">
        <h2 class="choose-box--heading">{{heading}}</h2>
        <img src="@/assets/images/pages/account/gifting/BUMPER-IMAGE-WIDE.jpg" alt="flower images"  class="choose-box--image">

        <div class="choose-box--container">
            <p class="choose-box--container--heading">{{$t('BUMPER_BOX_CHOOSE_SIZE')}}</p>
            <div class="choose-box--container--options">
                <div class="choose-box--container--options--standard" @click="selectBox(false)">
                    <h2 class="choose-box--container--options--standard--heading" :class="{ active: !bumperBoxSelected }">{{$t('BUMPER_BOX_STANDARD')}}</h2>
                    <p class="choose-box--container--options--standard--price">{{`£${standardBoxPrice} a box`}}</p>
                </div>
                <div class="choose-box--container--options--bumper" @click="selectBox(true)">
                    <h2 class="choose-box--container--options--bumper--heading" :class="{ active: bumperBoxSelected }">{{$t('BUMPER_BOX_BUMPER', { theBox: bumperBoxName })}}</h2>
                    <p class="choose-box--container--options--bumper--price">{{`£${bumperBoxPrice} a box`}}</p>
                </div>
            </div>
            <p class="choose-box--container--text">{{text}}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PRODUCT_FAMILY_BUMPER, PRODUCT_FAMILY_STANDARD, DISPLAY_NAME_BUMPER } from '@/constants/Gifting';
import IncompleteRegistrationService from '@/services/users/incompleteRegistrationService/IncompleteRegistrationService';
import { getBoxPrice } from '@/helpers/QueryHelpers';

export default {
    name: 'BumperBoxCheckOut',
    data() {
        return {
            bumperBoxSelected: false,
            bumperBoxName: DISPLAY_NAME_BUMPER,
        };
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAvailableDeliveryDay', this.deliveryAddress.postcode);
    },
    computed: {
        ...mapGetters({
            products: 'subscription/getProductTypes',
            deliveryAddress: 'register/getDeliveryAddress',
            boxPrice: 'register/getBoxPrice',
            deliveryPrice: 'register/getDeliveryPrice',
        }),
        currency() {
            return this.$store.getters['localisation/getCurrency'];
        },
        heading() {
            return this.bumperBoxSelected ? this.$t('CHECKOUT_BUMPER_BOX_TITLE_CLASSIC') : this.$t('CHECKOUT_BUMPER_BOX_TITLE', { theBox: DISPLAY_NAME_BUMPER });
        },
        text() {
            return this.bumperBoxSelected ? this.$t('CHECKOUT_BUMPER_BOX_TEXT') : this.$t('CHECKOUT_BUMPER_BOX_TEXT_CLASSIC');
        },
        price() {
            return this.bumperBoxSelected ? process.env.VUE_APP_BUMPER_BOX_PRICE : process.env.VUE_APP_BOX_PRICE;
        },
        buttonText() {
            return this.bumperBoxSelected ? this.$t('CHECKOUT_BUMPER_BOX_BUTTON_TEXT') : this.$t('CHECKOUT_BUMPER_BOX_BUTTON_TEXT_CLASSIC');
        },
        selectedBoxName() {
            return this.bumperBoxSelected ? PRODUCT_FAMILY_BUMPER : PRODUCT_FAMILY_STANDARD;
        },
        selectedBoxID() {
            return this.products.find(product => product.product_family.toLowerCase() === this.selectedBoxName).id;
        },
        bumperBoxPrice() {
            return process.env.VUE_APP_BUMPER_BOX_PRICE;
        },
        standardBoxPrice() {
            return getBoxPrice(this.boxPrice, this.deliveryPrice);
        },
    },
    methods: {
        selectBox(boxType) {
            this.bumperBoxSelected = boxType;
            this.onClickUpgrade();
        },
        onClickUpgrade() {
            this.$store.commit('register/setSelectedProductID', this.selectedBoxID);
            this.$store.commit('register/setSelectedProductName', this.selectedBoxName);
            (new IncompleteRegistrationService()).updateOrCreate();
        },
    },
};
</script>

<style lang="scss" scoped>
.choose-box {
    margin: 40px auto;
    margin-bottom: 20px;
    max-width: 700px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &--image {
        width: 100%;
        max-width: 500px;
        display: block;
    }
    &--heading {
        width: 100%;
        padding: 0 20px;
        text-align: center;
    }
    &--container {
        width: 100%;
        max-width: 500px;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        &--text {
            text-align: center;
            margin: 30px auto;
        }
        button {
            min-width: fit-content;
            padding: 10px 40px;
        }
    }
}

.choose-box--container {
        width: 100%;
        max-width: 500px;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        &--heading {
            text-align: center;
            font-weight: 400;
        }
        &--text {
            text-align: center;
            margin: 20px auto;
        }
        &--info {
            text-align: center;
            margin-bottom: 10px ;
            font-size: 15px;
        }
        &--sub-heading {
            text-align: center;
            margin: 20px 10px auto;
        }
        &--options {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            gap: 20px;
            &--bumper, &--standard {
                &--price {
                    text-align: center;
                    font-weight: 600;
                }
                &--heading {
                    font-size: 25px;
                    padding: 5px 20px;
                    opacity: 0.5;
                }
                &:hover {
                    cursor: pointer;
                }
            }

        }
        button {
            min-width: 200px;
        }
    }
.active {
    opacity: 1;
    border: 1px solid #1a1a1a;
}
</style>
